export default __webpack_public_path__ + "static/media/jquery.46a6977f.png";